var map = {
	"./fighters/fighters.module": [
		"./src/app/fighters/fighters.module.ts",
		"common",
		"fighters-fighters-module"
	],
	"./offers/offers.module": [
		"./src/app/offers/offers.module.ts",
		"common",
		"offers-offers-module"
	],
	"./scripts/scripts.module": [
		"./src/app/scripts/scripts.module.ts",
		"scripts-scripts-module"
	],
	"./settings/settings.module": [
		"./src/app/settings/settings.module.ts",
		"settings-settings-module"
	],
	"./users/users.module": [
		"./src/app/users/users.module.ts",
		"common",
		"users-users-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;